/* eslint-disable react/destructuring-assignment */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { mergeQueryString } from 'bernie-core';
import { EGDSMenu, EGDSMenuContainer, EGDSMenuList, EGDSMenuTrigger } from '@egds/react-core/menu';
import { EGDSIcon, EGDSIconSize } from '@egds/react-core/icons';
import { EGDSTertiaryButton } from '@egds/react-core/button';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { withRouter } from '../../../../common/utils/with-router';
var HeaderCurrencyToolbarComponent = /** @class */ (function (_super) {
    __extends(HeaderCurrencyToolbarComponent, _super);
    function HeaderCurrencyToolbarComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        return _this;
    }
    HeaderCurrencyToolbarComponent.prototype.toggleMenu = function () {
        var isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        });
    };
    HeaderCurrencyToolbarComponent.prototype.url = function (currencyId) {
        var location = this.props.location;
        var queryParams = {
            currency: currencyId
        };
        var queryString = mergeQueryString(location.search, queryParams);
        return "".concat(location.pathname, "?").concat(queryString);
    };
    HeaderCurrencyToolbarComponent.prototype.render = function () {
        var _this = this;
        var currencies = this.props.currencies;
        if (!currencies
            || !currencies.alternativeCurrencies
            || !currencies.currentCurrency) {
            return null;
        }
        var alternativeCurrencies = currencies.alternativeCurrencies, currentCurrency = currencies.currentCurrency;
        var currencyItems = alternativeCurrencies.map(function (currency) { return ({
            className: 'uitk-list-item',
            label: currency.displayCurrency,
            href: _this.url(currency.currencyId),
            typeAnchor: true,
            attributes: {
                role: 'menuItem',
                tabindex: 0
            }
        }); });
        return (React.createElement(EGDSSpacing, { padding: { inlineend: 'four' } },
            React.createElement("div", { className: "currencyLinkItems" },
                React.createElement(EGDSMenu, { isOpen: this.state.isOpen, onTriggerClick: this.toggleMenu },
                    React.createElement(EGDSMenuTrigger, null,
                        React.createElement(EGDSTertiaryButton, null,
                            React.createElement(EGDSIcon, { name: "expand_more", size: EGDSIconSize.SMALL }),
                            currentCurrency.displayCurrency)),
                    React.createElement(EGDSMenuContainer, null,
                        React.createElement(EGDSMenuList, { items: currencyItems }))))));
    };
    return HeaderCurrencyToolbarComponent;
}(React.Component));
export var HeaderCurrencyToolbar = withRouter(HeaderCurrencyToolbarComponent);
//# sourceMappingURL=header-currency-toolbar.js.map